import * as React from 'react';

export function AssignmentPaperSVG(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5 22H19C20.1046 22 21 21.1046 21 20V8L15 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22Z"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M7 7H10"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 12H17"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 17H17"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 2V6C15 7.10457 15.8954 8 17 8H21"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
}
